import React, {useEffect} from "react";
const Dependent =() => {
     useEffect(() => {
                    const scriptUrls = [
                      "assets/js/jquery-3.7.1.min.js",
                      "assets/plugins/jquery-ui/jquery-ui.min.js",
                      "assets/js/bootstrap.bundle.min.js",
                      "assets/plugins/theia-sticky-sidebar/ResizeSensor.js",
                      "assets/plugins/theia-sticky-sidebar/theia-sticky-sidebar.js",
                      "assets/plugins/select2/js/select2.min.js",
                      "assets/js/moment.min.js",
                      "assets/js/bootstrap-datetimepicker.min.js",
                      "assets/js/script.js",
                      "assets/js/profile-settings.js"
                    ];
                
                    let isCancelled = false;
                
                    const loadScriptsSequentially = async () => {
                      for (const url of scriptUrls) {
                        if (isCancelled) break;
                
                        await new Promise((resolve, reject) => {
                          const script = document.createElement('script');
                          script.src = url;
                          script.async = false;
                          script.onload = () => {
                            console.log(`Loaded: ${url}`);
                            resolve();
                          };
                          script.onerror = () => {
                            console.error(`Failed to load: ${url}`);
                            reject();
                          };
                          document.body.appendChild(script);
                        });
                      }
                
                      // Now init plugins after scripts are loaded
                      if (!isCancelled) {
                        // if (window.AOS) {
                        //   window.AOS.init();
                        // }
                
                        if (window.$ && typeof window.$.fn.datetimepicker === 'function') {
                          window.$('.datetimepicker').datetimepicker();
                        }
                
                        if (typeof window.initBackToTop === 'function') {
                          window.initBackToTop(); // assuming your backToTop script defines this
                        }
                
                        console.log('All scripts loaded and initialized.');
                      }
                    };
                
                    loadScriptsSequentially();
                
                    return () => {
                      isCancelled = true;
                    };
                  }, []);
    return (<div className="col-lg-8 col-xl-9">
  <div className="dashboard-header">
    <h3>Dependants</h3>
  </div>
  <div className="dashboard-header border-0 m-0">
    <ul className="header-list-btns">
      <li>
        <div className="input-block dash-search-input">
          <input type="text" className="form-control" placeholder="Search" />
          <span className="search-icon"><i className="isax isax-search-normal" /></span>
        </div>
      </li>
    </ul>
    <button className="btn btn-md btn-primary-gradient rounded-pill" data-bs-toggle="modal" data-bs-target="#add_dependent">Add  Dependants</button>
  </div>
  {/* Depeendent Item */}
  <div className="dependent-wrap">
    <div className="dependent-info">
      <div className="patinet-information">
        <a href="/">
          <img src="assets/img/dependent/dependent-01.jpg" alt="User " />
        </a>
        <div className="patient-info">
          <h5>Laura</h5>
          <ul>
            <li>Mother</li>
            <li>Female</li>
            <li>58 years 20 days</li>
          </ul>
        </div>
      </div>
      <div className="blood-info">
        <p>Blood Group</p>
        <h6>AB+ve</h6>
      </div>
    </div>
    <div className="dependent-status">
      <div className="status-toggle">
        <input type="checkbox" id="status_1" className="check" defaultChecked />									
        <label htmlFor="status_1" className="checktoggle">checkbox</label>
      </div>
      <button className="edit-icon me-2" data-bs-toggle="modal" data-bs-target="#edit_dependent"><i className="isax isax-edit-2" /></button>
      <button className="edit-icon" data-bs-toggle="modal" data-bs-target="#delete_modal"><i className="isax isax-trash" /></button>
    </div>
  </div>
  {/* /Depeendent Item */}
  {/* Depeendent Item */}
  <div className="dependent-wrap">
    <div className="dependent-info">
      <div className="patinet-information">
        <a href="/">
          <img src="assets/img/dependent/dependent-02.jpg" alt="User " />
        </a>
        <div className="patient-info">
          <h5>Mathew</h5>	
          <ul>
            <li>Father</li>
            <li>Male</li>
            <li>59 years 15 days</li>
          </ul>
        </div>
      </div>
      <div className="blood-info">
        <p>Blood Group</p>
        <h6>AB+ve</h6>
      </div>
    </div>
    <div className="dependent-status">
      <div className="status-toggle">
        <input type="checkbox" id="status_2" className="check" defaultChecked />									
        <label htmlFor="status_2" className="checktoggle">checkbox</label>
      </div>
      <button className="edit-icon me-2" data-bs-toggle="modal" data-bs-target="#edit_dependent"><i className="isax isax-edit-2" /></button>
      <button className="edit-icon" data-bs-toggle="modal" data-bs-target="#delete_modal"><i className="isax isax-trash" /></button>
    </div>
  </div>
  {/* /Depeendent Item */}
  {/* Depeendent Item */}
  <div className="dependent-wrap">
    <div className="dependent-info">
      <div className="patinet-information">
        <a href="/">
          <img src="assets/img/dependent/dependent-03.jpg" alt="User " />
        </a>
        <div className="patient-info">
          <h5>Christopher</h5>
          <ul>
            <li>Brother</li>
            <li>Male</li>
            <li>32 years 6 Months</li>
          </ul>
        </div>
      </div>
      <div className="blood-info">
        <p>Blood Group</p>
        <h6>A+ve</h6>
      </div>
    </div>
    <div className="dependent-status">
      <div className="status-toggle">
        <input type="checkbox" id="status_3" className="check" defaultChecked />									
        <label htmlFor="status_3" className="checktoggle">checkbox</label>
      </div>
      <button className="edit-icon me-2" data-bs-toggle="modal" data-bs-target="#edit_dependent"><i className="isax isax-edit-2" /></button>
      <button className="edit-icon" data-bs-toggle="modal" data-bs-target="#delete_modal"><i className="isax isax-trash" /></button>
    </div>
  </div>
  {/* /Depeendent Item */}
  {/* Depeendent Item */}
  <div className="dependent-wrap">
    <div className="dependent-info">
      <div className="patinet-information">
        <a href="/">
          <img src="assets/img/dependent/dependent-04.jpg" alt="User " />
        </a>
        <div className="patient-info">
          <h5>Elisa</h5>
          <ul>
            <li>Sister</li>
            <li>Female</li>
            <li>28 years 4 Months</li>
          </ul>
        </div>
      </div>
      <div className="blood-info">
        <p>Blood Group</p>
        <h6>B+ve</h6>
      </div>
    </div>
    <div className="dependent-status">
      <div className="status-toggle checked">
        <input type="checkbox" id="status_4" className="check" />									
        <label htmlFor="status_4" className="checktoggle">checkbox</label>
      </div>
      <button className="edit-icon me-2" data-bs-toggle="modal" data-bs-target="#edit_dependent"><i className="isax isax-edit-2" /></button>
      <button className="edit-icon" data-bs-toggle="modal" data-bs-target="#delete_modal"><i className="isax isax-trash" /></button>
    </div>
  </div>
  {/* /Depeendent Item */}
</div>);
}
export default Dependent;


